import SectionHeading from '@/components/base/SectionHeading';
import { psychologyPoints } from '@/mocks/home';

export default function Psychology() {
  return (
    <section id="psych" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          align="center"
          eyebrow="吃瓜心理学"
          title="围观的时候，大脑在偷偷做什么"
          desc="吃瓜从来不只是「看热闹」。下面这六个机制，几乎解释了每一次你忍不住点开的瞬间。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {psychologyPoints.map((point, index) => (
            <article
              key={point.id}
              className="bg-background-50 rounded-lg border border-background-200 p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center justify-between">
                <span
                  className={`w-12 h-12 rounded-lg flex items-center justify-center text-2xl ${
                    index % 3 === 0
                      ? 'bg-primary-100 text-primary-700'
                      : index % 3 === 1
                        ? 'bg-accent-100 text-accent-700'
                        : 'bg-secondary-100 text-secondary-800'
                  }`}
                >
                  <i className={point.icon} />
                </span>
                <span className="font-heading text-3xl text-background-300">
                  {String(index + 1).padStart(2, '0')}
                </span>
              </div>
              <h3 className="font-heading text-lg text-foreground-950 mt-4">{point.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{point.desc}</p>
            </article>
          ))}
        </div>

        <aside className="mt-8 md:mt-10 rounded-lg bg-primary-900 text-background-100 p-6 md:p-8 flex flex-col md:flex-row md:items-center gap-5">
          <span className="w-14 h-14 rounded-full bg-accent-500 text-background-50 flex items-center justify-center flex-shrink-0">
            <i className="ri-lightbulb-line text-2xl" />
          </span>
          <div>
            <h3 className="font-heading text-lg md:text-xl text-background-50">一句话总结</h3>
            <p className="mt-1.5 text-sm md:text-base leading-relaxed text-background-200">
              围观之所以让人上瘾，是因为它同时满足了好奇、社交、情绪和安全感四种需求，而且几乎没有成本。
            </p>
          </div>
        </aside>
      </div>
    </section>
  );
}